import { defineStore } from 'pinia'
import { ref } from 'vue'
import { OBITUARY_REPORT_ERROR, netClient, type CommonResponse } from '@/apis/api'
/**
 * 目前四个账户轮换使用，轮换规则：https://uz2e1toqs0.feishu.cn/wiki/YoeSwwVPEiCerRkHVgycJMy4nWh?fromScene=spaceOverview
 */

interface AccountInfo {
  id: number
  category: 'Personal' | 'Commercial'
  period: Array<number>
  key: string
  securityJsCode: string
}

const accountInfo: Array<AccountInfo> = [
  {
    id: 1,
    category: 'Personal',
    period: [1, 2, 3, 4],
    key: 'd8206cc38e0410f5506200490c8ae0f2',
    securityJsCode: '673f2c33735b8acf734536ccafb06e47'
  },
  {
    id: 2,
    category: 'Personal',
    period: [5, 6, 7, 8],
    key: 'df6ad7a5fc044cc1a33af3146cfb591e',
    securityJsCode: '243f6a6e5a88a5ede1e51c5e94084d4a'
  },
  //备用
  {
    id: 3,
    category: 'Commercial',
    period: [],
    key: 'b8f4ba399d91155864ef5207de152918',
    securityJsCode: 'fab9fd22a40854586174e620c3189b2a'
  },

  {
    id: 4,
    category: 'Personal',
    period: [9, 10, 11, 12],
    key: 'c6c5e59ab23d197dcb4651c193c060e9',
    securityJsCode: 'e7abca92cbf5c7d65cb8c90b1aa7db90'
  },

  {
    id: 5,
    category: 'Personal',
    period: [13, 14, 15, 16],
    key: '6901c63062850340d1edd1701da9086d',
    securityJsCode: 'a2cc310b8c3f29c4d22039f40b4adf74'
  },
  {
    id: 6,
    category: 'Personal',
    period: [17, 18, 19, 20],
    key: '284f31757e0cc9deefdf387fa84a73e4',
    securityJsCode: 'ed0aa2552f2e0e6db0e64c508ec39baa'
  },
  {
    id: 7,
    category: 'Personal',
    period: [21, 22, 23, 24],
    key: '02803516c84f1dc43946d3a4627ed1b8',
    securityJsCode: 'cb86168a860c4e912e3502fd74b62271'
  },
  {
    id: 8,
    category: 'Personal',
    period: [25, 26, 27, 28],
    key: '27103a2efdbef5393c3e171a2eb44913',
    securityJsCode: 'decc744eba5779cb2ab84d81dd8228dc'
  },
  {
    id: 9,
    category: 'Personal',
    period: [29, 30, 31],
    key: 'f27043c0365a7cee3e9b7abf8e96b688',
    securityJsCode: '33169070ffaca44777b465c3eea90b84'
  }
]
export const useAccountStore = defineStore('account', () => {
  const currentAccount = ref<AccountInfo | null>(null)

  const backupAccount = ref<AccountInfo>({
    id: 3,
    category: 'Commercial',
    period: [],
    key: 'b8f4ba399d91155864ef5207de152918',
    securityJsCode: 'fab9fd22a40854586174e620c3189b2a'
  })

  const initAccount = () => {
    if (currentAccount.value) {
      console.log('Account Info 已经初始化，跳过计算。')
      return
    }

    console.log('--- 首次执行账户信息计算 ---')
    const currentDate = new Date()
    const currentDay = currentDate.getDate()
    //let currentDay = 40;
    console.log('currentDay', currentDay)
    const account = accountInfo.find((item) => item.period.includes(currentDay))
    if (!account) {
      console.log('没有可以使用的账号,使用备用账号')
      currentAccount.value = backupAccount.value
      return
    }
    currentAccount.value = account
    console.log('currentAccount', currentAccount.value)
  }

  return {
    backupAccount,
    currentAccount,
    initAccount
  }
})
// /v1/obituary/alertMap?key=xxx&reason=xxxx&extraInfo=xxxxx
export function reportError(errorKey: string, reason: string, extraInfo: string | null) {
  return netClient.request<CommonResponse<string>>(OBITUARY_REPORT_ERROR, 'get', {
    key: errorKey,
    reason: reason,
    extraInfo: extraInfo
  })
}
